import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

type Languages = 'en' | 'ar';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private translations: any = {};
  private currentLang = new BehaviorSubject<Languages>('en');
  lang$ = this.currentLang.asObservable();

  constructor(private http: HttpClient) {
    this.init()
  }

  init() {
    const saved = localStorage.getItem('lang') as Languages;
    this.use(saved || 'en');
  }

  use(lang: Languages) {
    this.http.get(`assets/i18n/${lang}.json`).subscribe(data => {
      this.translations[lang] = data;
      this.currentLang.next(lang);
      localStorage.setItem('lang', lang);
    });
  }

  get(key: string): string {
    const lang = this.currentLang.value;
    const keys = key.split('.');
    let value = this.translations[lang];
    for (let part of keys) {
      value = value?.[part];
      if (!value) break;
    }
    return value || key;
  }
}
